import React from "react";
import SourceObjectConfiguratorStep from "./SourceObjectConfiguratorStep";

const SourceTargetsStep = (props) => (
  <SourceObjectConfiguratorStep {...props} />
);

export default SourceTargetsStep;
